import React from "react";
import styles from "./Conclusion.module.scss";
import Button from './Global/Button';

export default function Conclusion() {
    return (
        <section className={styles.Main}>
            <div className="container">
                <span className={['h1', styles.Title].join(' ')}>Et pour 2023 ? </span>

                <div className={styles.Content}>
                    <p>
                        Beaucoup des sujets parmi les 10 évoqués ici vont rester au menu du début de l’exercice à suivre : la question centrale qui demeure est jusqu'où la remontée des taux pourrait se prolonger ? Cela dépendra de nombreux facteurs, notamment du comportement de l'inflation, de la sévérité de la récession, du niveau des profits des entreprises et de l’évolution de la guerre en Ukraine. Un des “driver” pourrait aussi être le réveil de la Chine, après deux années de sous-performance. En effet, si l’assouplissement des restrictions s’avérait durable, cela pourrait constituer une thématique géographique intéressante. Les tensions internationales risquent malheureusement de se poursuivre, la remontée des taux pourrait se prolonger jusqu’à l’été prochain, tandis que la transition énergétique va prendre encore de longues années… avec toujours plus de défis technologiques à relever. Ce qui signifie aussi autant d’opportunités à saisir pour les investisseurs qui suivent les marchés au quotidien avec eToro !
                    </p>

                    <Button external={true} url={'https://ad.doubleclick.net/ddm/clk/549052260;358217871;k'} text={'Investissez maintenant'}/>
                </div>
            </div>

            <div className={styles.Legal}>
                <div className={'container'}>
                    <p>
                        <small>
                            Le Copy Trading ne constitue pas un conseil en investissement. La valeur de vos placements peut augmenter ou diminuer. Votre capital est assujetti à un risque. <br/>
                            Cette communication est uniquement destinée à des fins d’information et d’éducation et ne doit pas être considérée comme un conseil en investissement ou une recommandation personnelle. <br/>
                            Les performances passées ne sont pas garantes des résultats futurs.
                        </small>
                    </p>
                </div>
            </div>
        </section>
    )
}